import React, { FC, useRef, useState } from 'react';
import { PtwDetailInfosComponent } from './PtwDetailInfosComponent';
import { Button, Header, Modal, Image, Container } from 'semantic-ui-react';
import { TranslationComponent } from '../TranslationComponent';
import { useReactToPrint } from 'react-to-print';
import { PtwDetailCompletionComponent } from './PtwDetailCompletionComponent';
import { PtwDetailHistoryComponent } from './PtwDetailHistoryComponent';
import { IBuilding, IProject, IPtw, IUser, IWorkstation } from '@relab/alstom-ptw-shared';
import ptwPrintHeader from '../../assets/images/ptw-print-header.png';

type Props = {
  user: IUser;
  project: IProject;
  buildings: IBuilding[];
  workstations: IWorkstation[];
  ptw: IPtw;
};

export const PtwDetailPdfExporter: FC<Props> = ({ user, project, buildings, workstations, ptw }) => {
  const [showModal, setShowModal] = useState(false);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => setShowModal(false),
  });

  return (
    <>
      <Button primary onClick={() => setShowModal(true)}>
        <TranslationComponent stringKey={'Print'} />
      </Button>

      <Modal onClose={() => setShowModal(false)} onOpen={() => setShowModal(true)} open={showModal}>
        <div style={{ marginTop: 30, marginLeft: 30, marginRight: 30 }} ref={componentRef}>
          <Container style={{ display: 'flex', justifyContent: 'center' }}>
            <Image src={ptwPrintHeader} />
          </Container>
          <Header textAlign={'center'}>{`${project.name} - ${ptw.name} - PTW #${ptw.sequentialNumber}`}</Header>
          <Modal.Content>
            <Header>
              <TranslationComponent stringKey={'Details'} />
            </Header>
            <PtwDetailInfosComponent
              user={user}
              project={project}
              buildings={buildings}
              workstations={workstations}
              ptw={ptw}
              ptwUpdateAction={() => null}
              onPtwUpdateRequest={() => null}
            />
            <hr />
            <Header>
              <TranslationComponent stringKey={'Work Status update'} />
            </Header>
            <PtwDetailCompletionComponent ptw={ptw} />
            <hr />
            <div style={{ breakAfter: 'page' }}></div>
            <Header>
              <TranslationComponent stringKey={'Permit History/Flow'} />
            </Header>
            <PtwDetailHistoryComponent ptw={ptw} />
          </Modal.Content>
        </div>
        <Modal.Actions>
          <Button primary onClick={() => setShowModal(false)}>
            <TranslationComponent stringKey={'Back'} />
          </Button>
          <Button primary onClick={handlePrint}>
            <TranslationComponent stringKey={'Print'} />
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
